<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px">


            <el-form-item label="文章标题" prop="title" :error="formErrorMsg.title" class="fb-form-item">
                <el-input  v-model="formData.title" placeholder="文章标题"></el-input>
            </el-form-item>

            <el-form-item label="文章副标题" prop="subTitle" :error="formErrorMsg.subTitle" class="fb-form-item">
                <el-input  v-model="formData.subTitle" placeholder="文章副标题"></el-input>
            </el-form-item>

            <el-form-item label="文章分类" prop="category" :error="formErrorMsg.category" class="fb-form-item">
                <cms-category-select v-model="formData.category" flag="DOCUMENT" disabled></cms-category-select>
            </el-form-item>

            <el-form-item label="文章内容" prop="content" :error="formErrorMsg.content" >
                <wangeditor v-model="formData.content" :upload-img-server="$api.cmsArticle.upload"></wangeditor>
            </el-form-item>

            <el-form-item label="摘要" prop="description" :error="formErrorMsg.description" class="fb-form-item">
                <el-input v-model="formData.description" placeholder="摘要"></el-input>
            </el-form-item>

            <el-form-item label="语言" prop="lang" :error="formErrorMsg.lang" class="fb-form-item">
                <dict-select type-flag="LANG" v-model="formData.lang"></dict-select>
            </el-form-item>

            <el-form-item label="封面" prop="cover" :error="formErrorMsg.cover" class="fb-form-item">
                <single-pic-uploader v-model="formData.cover" category="CMS_CATEGORY_COVER"></single-pic-uploader>
            </el-form-item>

            <el-form-item label="排序" prop="sortNum" :error="formErrorMsg.sortNum" class="fb-form-item">
                <el-input v-model="formData.sortNum" placeholder="排序"></el-input>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>

    import SinglePicUploader from "../../components/SinglePicUploader";
    import CmsCategorySelect from "../../components/CmsCategorySelect";
    import Wangeditor from "../../components/Wangeditor";
    export default {
        name: "PartnerEdit",
        components: {Wangeditor, CmsCategorySelect, SinglePicUploader},
        data() {
            return {
                api:{
                   update:this.$api.cmsArticle.update,
                   detail:this.$api.cmsArticle.detail,
                },
                formErrorMsg:{
                    title: '',
                    subTitle:'',
                    cover: '',
                    sortNum:'',
                    content:'',
                    category:'',
                    keywords:'',
                    description:'',
                    firstPic:"",
                    publishTime:""
                },
                formData: {
                    code:'',
                    title: '',
                    subTitle:'',
                    cover: '',
                    sortNum:'',
                    content:'',
                    category:'',
                    keywords:'',
                    description:'',
                    firstPic:"",
                    publishTime:"",
                    lang:'en'
                },
                rules: {
                    title: [
                        {required: true, message: '文章标题不能为空', trigger: 'blur'},
                    ],
                    category: [
                        {required: true, message: '请选择文章分类', trigger: 'blur'},
                    ],lang: [
                        {required: true, message: '请选择语言类型', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });
                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey];
                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>


<style>

    .editor-item{
         position: relative;
    }

    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>